// src/components/auth/RequireAuth.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "../../contexts/MeContext";

/**
 * ログイン必須ガード
 * - 未ログイン → /entry に強制リダイレクト
 * - ローディング中 → 何も描画しない（チラ見え防止）
 */
const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { me, loading } = useMe();
  const location = useLocation();

  // 判定中は画面を出さない
  if (loading) return null;

  // 未ログイン → /entry に飛ばす
  if (!me) {
    const qs = location.search || "";
    return <Navigate to={`/entry${qs}`} replace />;
  }

  // ログイン済み
  return <>{children}</>;
};

export default RequireAuth;
